<template>
  <div>
    <Form></Form>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Form from '@/components/admin/video/videoPostUser/formVideoUser'

export default {
  name: "postVideoUser",
  components: {Form},
  computed: {
  },
  //Appelé au chargement de la page
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$i18n.t('sidebar.posteVideosMenu') }]); //Fil d'ariane
  },
  metaInfo: {
    // Les enfants peuvent remplacer le titre.
    title: 'Poste tes vidéos',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Poste les vidéos de l\'application TellMeGenius.'}
    ]
  }
};
</script>
